import { AsyncStateNotification } from '../AsyncStateNotification';
import { coreActions } from '@sonar-software/sonar-core';
import { createSonarSelector } from '@lib/selectors';
import React from 'react';
import { COPY_GENERIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';

export interface BulkOwnerNotificationProps {
	autoReset?: boolean;
}

const selector = createSonarSelector((state) => state.core.sonarObjects.users.bulk.put);

export const BulkOwnerNotification: React.FC<BulkOwnerNotificationProps> = ({ autoReset }) =>
	<AsyncStateNotification
		errored={ COPY_GENERIC.CONTACT_SUPPORT }
		failed={ COPY_GENERIC.CONTACT_SUPPORT }
		received={ NOTIFICATIONS_COPY.SUCCESS_PUT_SONAR_OBJECTS_USERS_BULK }
		resetRawAction={ autoReset ? coreActions.resetPutCoreSonarObjectsUsersBulk : undefined }
		stateSelector={ selector } />;

